
import CommunicationAPIService from '@/modules/communication/services/apiService'


export default class CommunicationModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.communicationService = new CommunicationAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/communication/notifications',
        name: 'NotificationList',
        component: () => import('@/modules/communication/views/notificationList.vue'),
        meta: {
          requiresAuth: true,
          hideBreadcrumbs: true,
          title: 'Notification Inbox',
          menuLink: '/'
        }
      }
    ]
  }
}
